<template>
  <audio v-if="audio" ref="media" :srcObject.prop="stream" autoplay @loadedmetadata="play" />
  <video v-else ref="media" :srcObject.prop="stream" :muted="muted" autoplay playsinline :class="{'chat-call-media--mirror':mirror}" @loadedmetadata="play" />
</template>
<script>
export default {
  props:{stream:Object,audio:Boolean,muted:Boolean,mirror:Boolean},
  watch:{stream() { this.$nextTick(this.play) }},
  mounted() { this.play() },
  beforeDestroy() { if(this.$refs.media) this.$refs.media.srcObject=null },
  methods:{play() { if(!this.stream || !this.$refs.media) return; const playing=this.$refs.media.play(); playing?.catch(error=>{ if(error.name==='NotAllowedError') this.$emit('blocked') }) }}
}
</script>
<style scoped>
video{display:block;width:100%;height:100%;object-fit:contain;background:#101725}.chat-call-media--mirror{transform:scaleX(-1)}
</style>
